import { SNAP_CENTER, SNAP_END } from "./constants";
export const getSnapOffset = (
  snap,
  offsetProp,
  itemOffset,
  itemSize,
  trackSize
) => {
  if (snap === SNAP_CENTER) {
    return (
      itemOffset * -1 + trackSize[offsetProp] / 2 - itemSize[offsetProp] / 2
    );
  }
  if (snap === SNAP_END) {
    return itemOffset * -1 + trackSize[offsetProp] - itemSize[offsetProp];
  }
  return itemOffset * -1;
};
